import * as React from 'react'
import { tryCatch } from '../../utils/tryCatch'
import { Schedule } from '../schedule/schedule'
import { EpisodeList } from '../episodeList/episodeList'
import { withFatalCheck } from '../error/withFatalCheck'
import { ICollection } from '../../selectors/collections'
import { CarouselCollection } from '../carousel/carouselCollection'
import * as stUtility from '../utilityClasses.module.scss'

interface OwnProps {
  hideHeader?: boolean
}

const CollectionValid = tryCatch((props: ICollection & OwnProps) => {
  switch (props.collectionType) {
    case 'schedule': return <Schedule {...props} />
    case 'carousel': return <div className={stUtility.pageSection}><CarouselCollection  {...props}/></div>
    default: return <EpisodeList {...props} />
  }
})

export const Collection = withFatalCheck(CollectionValid)
